<template>
    <section class="ssection-hero section-shaped my-0" id="container">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <div class="container">
                          <card shadow class="card-profile" no-body>
                              <div class="px-2">
                                  <div class="row justify-content-center">
                                      <div class="col">
                                            <img :src="image_vision" >
                                            <p>แตะรูปกล้อง แล้วใส่รูปขวด</p>
                                            <input id="image-file" type="file" @change="onFileChange" hidden>

                                            <div class="col align-items-center" style="width: 100%; height: 100%;"  onmouseover="this.bgColor='white'">
                                                <img :src="image" v-on:click="chooseFiles" class="border mixed" >
                                            </div>

                                            <loading :active.sync="isLoading" 
                                            :can-cancel="true" 
                                            :on-cancel="onCancel"
                                            :is-full-page="fullPage"></loading>
                                      </div>
                                  </div>
                                  <div class="row justify-content-center">
                                    <div class="col"  id="imgresult" > 
                                                <div style="width: 100%; height: 120%;">
                                                  <p id="prodResult"></p>
                                                  <a href="https://www.scg.com/sustainability/circular-economy/knowledge/1">Show more</a>
                                                   <br>
                                                   <div>
                                                     <br><br>
                                                  </div>
                                                </div>
                                      </div>
                                  </div>
                                  
                              </div>

                              <div class="row justify-content-center">
                                    <div class="col"  id="imgresult" > 
                                                <div style="width: 100%; height: 120%;">
                                                  <br><br><br><br><br><br><br>
                                                </div>
                                      </div>
                                  </div>
                          </card>
                      </div>
                    </div>
                </div>

              <div class="container">
                  
                  <!-- Modals -->
                  <modals></modals>
                  
              </div>
    </section>
</template>
<script>
import Modals from "./JavascriptComponents/ModalsResult";
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const axios = require('axios');

export default {
  data() {
    return {
      msg: "Product detection",
      hasImage: false,
      image:  'img/prd/Select-Picture.png',
      image_vision:  'img/brand/Koomkah-Vision.png',

      image0: 'img/prd/tp0.png',
      image1: 'img/prd/tp1.png',
      image2: 'img/prd/tp2.png',
      image3: 'img/prd/tp3.png',
      image4: 'img/prd/tp4.png',
      image5: 'img/prd/tp5.png',
      image6: 'img/prd/tp6.png',

      image7: 'img/tb/g0.jpg',
      image8: 'img/tb/g1.jpg',

      info:'Respond :',
      isLoading: false,
      fullPage: true
    
    };
  },  
  components: {
    Modals,
    Loading
  },
  mounted () {
    var divRes = document.getElementById("imgresult");
      divRes.style.display = "none";
     var divRes = document.getElementById("imgresult");
      divRes.style.display = "none";  

  },
  methods: {

    chooseFiles: function() {
        document.getElementById("image-file").click()
    },
    onFileChange(e) {

      var divRes = document.getElementById("imgresult");
      divRes.style.display = "none";

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
      {
        window.alert("Same image");
        return;
      }
      this.createImage(files[0]);
      var productName = document.querySelector(".product-resp");
      
      let photo = document.getElementById("image-file").files[0];
      let formData = new FormData();

      formData.append("file", photo);
      var lookup = {"PETBOTTLE": "detail PETBOTTLE", "Lid": "detail Lid"};
      var x = 0;
      var array = Array();
      this.isLoading = true;

      axios({
          method: 'post',
          url: 'https://dev.scgd.co/vsml',
          data: formData,
          headers: {'Content-Type': 'multipart/form-data' ,
                    "Authorization" :"Basic c2NnMDk4MTIzMjM6U0NHY2hlbTg3OTU4NDIxNTc="}
          })
          .then(function (response) {

              //handle success
              var str = response.data.prod;
              var modl = [/Not found/gi,/Nolabel/gi,/label/gi,
                          /NoLid/gi,/LID/gi,
                          /PETBOTTLE/gi,/Colourless/gi,/AMBERGLASS/gi,/GREENGLASS/gi,
                          /CLEARGLASS/gi,/HDPEBOTTLE/gi,/OPAQUEPLASTIC/gi,/Bioplastic/gi,
                          /Translucent/gi,/Plastic/gi,/DrinkingBottle/gi,/WhiteColour/gi,
                          /WhiteColour/gi,/OTHERGLASS/gi];
              

                var showIndex = {
                            "NOT FOUND"      : ["ไม่พบชนิดสินค้า"    ,"#","notfound.jpg"  ,'no',"notfound.jpg"," "],
                            "LABEL"          : ["ฉลาก"            ,"#","label.png"     ,'yes',"8.png","กรวยจราจร"],
                            "NOLABEL"        : ["ไม่มีฉลาก"         ,"#","Nolabel.jpg"   ,'no',"notfound.jpg"," "],
                            "LID"            : ["ฝาขวด"           ,"#","Lid.jpg"       ,'yes',"9.png","ชิ้นส่วนรถยนต์"],
                            "NOLID"          : ["ไม่มีฝาขวด"        ,"#","PET_NOLID.jpg" ,'no',"notfound.jpg"," "],
                            "PETBOTTLE"      : ["ขวดพลาสติกใส"     ,"#","PET.jpg"       ,'yes',"3.png","เสื้อกันหนาว"],
                            "COLOURLESS"     : ["ขวดใสไม่มีสี"       ,"#","Colourless.jpg" ,'yes',"3.png","เสื้อกันหนาว"],
                            "AMBERGLASS"     : ["ขวดแก้วสีชา"       ,"#","amber.png"      ,'yes',"1.png","เเก้ว"],
                            "CLEARGLASS"     : ["ขวดแก้วสีใส"       ,"#","clearglass.jpg" ,'yes',"1.png","เเก้ว"],
                            "GREENGLASS"     : ["ขวดแก้วสีเขียว"     ,"#","Greenglass.jpg" ,'yes',"1.png","เเก้ว"],
                            "HDPEBOTTLE"     : ["พลาสติกเหนียว"     ,"#","HDPEBOTTLE.jpg",'yes',"2.png","แท่งไม้เทียม"],
                            "OPAQUEPLASTIC"  : ["พลาสติกทึบ/ขุ่น"    ,"#","Opaqueplastic_tr.png",'yes',"2.png","แท่งไม้เทียม"],
                            "BIOPLASTIC"     : ["พลาสติกชีวภาพ"    ,"#","BioPlastic.png",'yes',"7.png","กระสอบปุ๋ย"],
                            "TRANSLUCENT"    : ["พลาสติกขุ่น"       ,"#","Translucentbottle.png",'yes',"2.png","แท่งไม้เทียม"],
                            "PLASTIC"        : ["พลาสติก"         ,"#","Plastic.jpg",'yes',"6.png","ไม้แขวนเสื้อ"],
                            "DRINKINGBOTTLE" : ["ขวดน้ำดื่มแบบขุ่น"   ,"#","DrinkingBottle_tr.png",'yes',"2.png","แท่งไม้เทียม"],
                            "WHITECOLOUR"    : ["ขวดสีขาว"        ,"#","Whitecolour.jpg",'yes',"2.png","แท่งไม้เทียม"],
                            "COLOUR"         : ["ขวดสี"           ,"#","COLOUR.jpg",'yes',"3.png","เสื้อกันหนาว"],
                            "OTHERGLASS"     : ["ขวดแก้ว สีอื่นๆ"    ,"#","otherglass.jpg","1.png","เเก้ว"]
                            
                            }; 
              
              if(str.match(modl[0]) != null)
              {
                 // array[0] = str.match(modl[0]);
              }else{
                var i=0,k=0;
                var found =[];
                var tmp='';
                for (i=0;i<modl.length;i++){

                  if( str.match(modl[i]) != null){
                    array[x] = str.match(modl[i]);
                    x++;
                    if( i == 1) //Skip Label condition 
                      i++; 
                    else if( i == 3)  //Skip Lid condition
                      i++; 
                    
                  }
                }

              }
              
              if(array.length > 0)
              {
                
                var e = "";
                  
                for (var y=0; y<array.length; y++)
                {
                  
                  if(showIndex[array[y].toString().toUpperCase()][0].toString().length < 8)
                        e += '<a >'+'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+'</a>';
                  e += '<a href="' + showIndex[array[y].toString().toUpperCase()][1].toString()+'" align="left">'+showIndex[array[y].toString().toUpperCase()][0]+'</a>';
                  if(showIndex[array[y].toString().toUpperCase()][3] == 'yes')
                  {
                      e += '<a >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>';
                      if(showIndex[array[y].toString().toUpperCase()][0].toString().length < 8)
                        e += '<a >'+'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+'</a>';

                      if(showIndex[array[y].toString().toUpperCase()][5].toString().length > 8)
                       e += '<a >'+'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+'</a>';  
                      e += '<a href="' + showIndex[array[y].toString().toUpperCase()][1].toString()+'" align="right">'+showIndex[array[y].toString().toUpperCase()][5]+'</a>';
                      
                  }
                  
                  
                  e += '<br><img src="img/prd/'+showIndex[array[y].toString().toUpperCase()][2].toString()+'"  style="width:80px;">';
                 

                  if(showIndex[array[y].toString().toUpperCase()][3] == 'yes')
                  {
                    e += '<img src="img/prd/recycle/Arrow.jpg"  style="width:80px;">';
                    e += '<img src="img/prd/recycle/'+showIndex[array[y].toString().toUpperCase()][4].toString()+'"  style="width:80px;"><br/>';
                  }
                  else e += '<br/>';

                }
                //document.getElementById("prodResult").innerHTML = e;
                document.getElementById("modal-title-notification").textContent = "ผลการค้นหา";
                document.getElementById("modal-title-content").innerHTML = e;
                document.getElementById("prodResult").innerHTML = '';
                divRes.style.display = "block";
                
              }
              else{

                var e = "<hr/>";   
                e += "<p1>"+ showIndex["NOT FOUND".toUpperCase()][0] + "</p1><br/>";
                e += '<br><img src="img/prd/'+showIndex["NOT FOUND".toUpperCase()][2].toString()+'"  style="width:80px;"></a><br/>';
                //document.getElementById("prodResult").innerHTML = e;
                document.getElementById("modal-title-notification").textContent = "ผลการค้นหา";
                document.getElementById("modal-title-content").innerHTML = e;

                document.getElementById("prodResult").innerHTML = '';
                divRes.style.display = "block";
                
              }
              
              divRes.style.display = "block";
              document.getElementById("calmodal").click();
              
              this.isLoading = false;
          
          })
          .catch(function (error) {
              //handle error
              

               if (error.response.status === 400) {
                   var e = "<hr/>";   
                    e += "<p1>"+ "ไฟล์รูปไม่รองรับ" + "</p1><br/>";
                    
                    document.getElementById("prodResult").innerHTML = e;
                    divRes.style.display = "block";
                }
                else{
                    var e = "<hr/>";   
                    e += "<p1> Can't connect server Error : "+ error.response.status + "</p1><br/>";
                    
                    document.getElementById("prodResult").innerHTML = e;
                    divRes.style.display = "block";

                }
              
          });

      setTimeout(() => {
        this.isLoading = false;
      },1500)
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      //this.image = '';
      //console.log("removeImage");
      this.isLoading = true;
     
    },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
img {
  width: 260px;
  margin: 2px;
}
button {
  margin-bottom: 10px;
}
.border { border-width: 30px; border-color: rgb(0, 0, 0); border-style: solid; }
.mixed { border-style: solid dashed dotted double; }


</style>
